// extracted by mini-css-extract-plugin
export var hgwIconArrowDown = "PinModal-module--hgwIcon-arrow-down--1GvNh";
export var hgwIconArrowUp = "PinModal-module--hgwIcon-arrow-up--3pDeS";
export var base = "PinModal-module--base--mggYn";
export var closeButton = "PinModal-module--closeButton--2RNns";
export var content = "PinModal-module--content--jIXcM";
export var container = "PinModal-module--container--135T_";
export var linkBlock = "PinModal-module--linkBlock--2vmZH";
export var animBarTypeA = "PinModal-module--animBarTypeA--1KIVx";
export var animBarTypeB = "PinModal-module--animBarTypeB--3LnhT";
export var animBarTypeC = "PinModal-module--animBarTypeC--10nbA";
export var animBarTypeD = "PinModal-module--animBarTypeD--1Q52o";